import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { HiArrowRight } from 'react-icons/hi';
import { FiArrowUpRight } from 'react-icons/fi';
import { allPosts } from '../../posts';
import { topics } from './config';
import { formatDate } from './utils';
import BlogHeader from './BlogHeader';
import BlogFooter from './BlogFooter';
import './blog.css';

const tickerWords = [
  'Backend', 'Kubernetes', 'PostgreSQL', 'Spring Boot', 'RAG', 'Terraform',
  'Docker', 'CI/CD', 'Observability', 'AWS', 'GCP', 'Microservices',
  'Fintech', 'Platform', 'Reliability',
];

const BlogList = () => {
  const latest = allPosts[0];

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Writing — Jonah Odoh';
  }, []);

  return (
    <div className="blog__page">
      <BlogHeader />

      {/* ── HERO ── */}
      <header className="blog__home-hero">
        <div className="container blog__home-hero-inner">
          <p className="blog__home-eyebrow">
            VOL. I · {String(allPosts.length).padStart(2, '0')} POSTS · UPDATED REGULARLY
          </p>
          <h1 className="blog__home-title">
            Shipped it.<br />
            Scaled it.<br />
            <em>Wrote it down.</em>
          </h1>
          <p className="blog__home-lead">
            An engineering blog by <strong>Jonah Odoh</strong>. Long-form notes on
            backend systems, DevOps, and the AI stack. Real patterns from real
            production work, not slideware.
          </p>
          <div className="blog__home-cta">
            {latest && (
              <Link to={`/blog/${latest.slug}`} className="btn primary">
                Read the latest <FiArrowUpRight />
              </Link>
            )}
            <a href="#all-posts" className="btn outline">Browse all posts</a>
          </div>
        </div>

        {/* moving ticker — same style as the portfolio header */}
        <div className="header__ticker" aria-hidden="true">
          <div className="header__ticker-track">
            {[...tickerWords, ...tickerWords].map((w, i) => (
              <span key={i} className="header__ticker-item">
                {w}
                <span className="header__ticker-dot">&nbsp;·&nbsp;</span>
              </span>
            ))}
          </div>
        </div>
      </header>

      {/* ── TOPIC CHIPS ── */}
      <div className="container blog__topicbar">
        {topics.map((t) => (
          <Link key={t.slug} to={`/blog/topic/${t.slug}`} className="blog__topicchip">
            {t.name}
          </Link>
        ))}
      </div>

      {/* ── POSTS ── */}
      <section id="all-posts" className="container blog__posts">
        <div className="blog__posts-head">
          <h2>All Posts</h2>
          <span>{String(allPosts.length).padStart(2, '0')} written</span>
        </div>

        <div className="blog__grid">
          {allPosts.map((post) => (
            <Link key={post.slug} to={`/blog/${post.slug}`} className="blog__card">
              <div className="blog__card-meta">
                <span className="blog__card-cat">{post.category}</span>
                <span className="blog__card-dot">•</span>
                <span>{formatDate(post.date)}</span>
              </div>
              <h3>{post.title}</h3>
              <p className="blog__card-excerpt">{post.excerpt}</p>
              <div className="blog__card-foot">
                <span>{post.readTime}</span>
                <span className="blog__card-more">
                  Read <HiArrowRight />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <BlogFooter />
    </div>
  );
};

export default BlogList;
